// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__RK77g","footer":"ModalError_footer__1QNbz"};